<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <div class="common-range-group">
            <div class="common-range-group__input">
                <input
                    v-model="fieldValue[0]"
                    :maxlength="9"
                    style="text-align:right"
                    type="text"
                    @keypress="isNumber($event)"
                    @blur="syncChange"
                >
            </div>
            <div class="common-range-group__separator" />
            <div class="common-range-group__input">
                <input
                    v-model="fieldValue[1]"
                    :maxlength="9"
                    placeholder="∞"
                    type="text"
                    style="text-align:left"
                    @keypress="isNumber($event)"
                    @blur="syncChange"
                >
            </div>
        </div>
    </FieldItem>
</template>

<script>
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        FieldItem,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'subject_length',
        },
    },
};
</script>
